import { Provider, createStore } from 'jotai'
import {
  memberListAtom,
  modelCodeAtom,
  optionsAtom,
  patternAtom,
  selectModelAtom,
  totalInfoAtom,
} from './ai-form/atom'
import {
  AiCreateArtworkModel,
  AiCreateArtworkPattern,
  getAIMemberList_accountModule_userMemberCardList,
  getAIMenu_pictureGraph_aiCreateArtworkOptionMenu,
  getAITotalInfo_pictureGraph_aiArtworkTotalInfo,
} from '~/graphqls/types'

export interface PageProps {
  options: getAIMenu_pictureGraph_aiCreateArtworkOptionMenu
  totalInfo: getAITotalInfo_pictureGraph_aiArtworkTotalInfo
  memberList: getAIMemberList_accountModule_userMemberCardList[]
  /** 锁定model版本 */
  lockModel: AiCreateArtworkModel
  /** 锁定modelCode */
  lockModelCode: number
  /** 锁定pattern */
  lockPattern: AiCreateArtworkPattern
}

const JotaiNextProvider: React.FC<{
  pageProps: PageProps
  children: React.ReactNode
}> = ({ pageProps, children }) => {
  const store = createStore()

  store.set(totalInfoAtom, pageProps.totalInfo)
  store.set(memberListAtom, pageProps.memberList)
  store.set(optionsAtom, pageProps.options)
  store.set(patternAtom, pageProps.lockPattern)
  store.set(modelCodeAtom, pageProps.lockModelCode)
  store.set(selectModelAtom, pageProps.lockModel)

  return <Provider store={store}>{children}</Provider>
}

export { JotaiNextProvider }
